import { Component } from '@theme/component';
import { RecentlyViewed } from '@theme/recently-viewed-products';
import { morphSection, sectionRenderer } from '@theme/section-renderer';

class ProductRecentlyViewed extends Component {
  #intersectionObserver = new IntersectionObserver(
    (entries, observer) => {
      if (!entries[0]?.isIntersecting) return;

      observer.disconnect();
      this.#loadRecentlyViewed();
    },
    { rootMargin: '0px 0px 400px 0px' }
  );

  #activeFetch = null;

  connectedCallback() {
    super.connectedCallback();
    this.#intersectionObserver.observe(this);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#intersectionObserver.disconnect();
    this.#activeFetch?.abort();
  }

  #loadRecentlyViewed() {
    const { sectionId, maxProducts, currentProductId, recentlyViewedPerformed } = this.dataset;

    if (!sectionId) return;

    if (recentlyViewedPerformed === 'true') return;

    let productIds = RecentlyViewed.getProducts();

    if (currentProductId) {
      productIds = productIds.filter((id) => id !== currentProductId);
    }

    const limit = parseInt(maxProducts || '10', 10);
    productIds = productIds.slice(0, limit);

    if (productIds.length === 0) {
      this.classList.add('hidden');
      return;
    }

    const url = new URL(window.Theme?.routes?.search_url || '/search', location.origin);
    url.searchParams.set('q', productIds.map((id) => `id:${id}`).join(' OR '));
    url.searchParams.set('resources[type]', 'product');

    this.#activeFetch?.abort();
    this.#activeFetch = new AbortController();

    sectionRenderer
      .getSectionHTML(sectionId, false, url)
      .then((html) => {
        if (!html?.trim()) {
          this.classList.add('hidden');
          return;
        }

        this.dataset.recentlyViewedPerformed = 'true';
        morphSection(sectionId, html, { mode: 'hydration', injectStylesheet: true });
      })
      .catch((error) => {
        if (error?.name === 'AbortError') return;
        console.error('Recently viewed products error:', error);
        this.classList.add('hidden');
      })
      .finally(() => {
        this.#activeFetch = null;
      });
  }
}

if (!customElements.get('product-recently-viewed')) {
  customElements.define('product-recently-viewed', ProductRecentlyViewed);
}
